module.exports = __webpack_public_path__ + "static/media/Workflux.d5615369.svg";